window.upi = Object.assign({}, window.upi || {});
function Namespace (nsString, scope) {
  let parts = nsString.split('.'),
    parent = scope || window.upi;

  // filter redundant ns global
  if (parts[0] === 'upi') {
    parts = parts.slice(1);
  }
  for (var i = 0, l = parts.length; i < l; i++) {
    // create ns if not exists
    if (typeof parent[parts[i]] === 'undefined') {
      parent[parts[i]] = {};
    }
    parent = parent[parts[i]];
  }
  return parent;
}

export { Namespace as default };
//# sourceMappingURL=Namespace.js.map
